import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-all-in-one-pc-manufacturer-india',
  templateUrl: './best-all-in-one-pc-manufacturer-india.component.html',
  styleUrls: ['./best-all-in-one-pc-manufacturer-india.component.scss']
})
export class BestAllInOnePcManufacturerIndiaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best All-in-One PC Manufacturer in India | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Looking for the best All-in-One PC in India? Explore VIRSA All-in-One PCs with Intel processor options, Full HD displays, expandable RAM, SSD storage, and modern connectivity.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Best All-in-One PC in India, Best All-in-One PC Provider in India, Best All-in-One PC Manufacturer in India, All-in-One Desktop PC, All-in-One Computer for Schools, All-in-One PC for Education, AIO PC Manufacturer India, All-in-One PC for Computer Labs, Business All-in-One PC, All-in-One PC Supplier India'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
